import { UpdateDocumentStatus } from 'domain/usecases/document/update-document-status'
import { DocumentRepository } from 'repository/interfaces/document-repository'

export class RemoteUpdateDocumentStatus implements UpdateDocumentStatus {
  constructor(private readonly documentRepository: DocumentRepository) {}

  async update(
    params: UpdateDocumentStatus.Params
  ): Promise<UpdateDocumentStatus.Model> {
    await this.documentRepository.updateDocumentStatus(params)
  }
}

export type UpdateDocumentStatusModel = UpdateDocumentStatus.Model
